import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { createList, ListDTO, SharedListMemberDTO } from 'src/app/interfaces/list';
import { environment } from 'src/environments/environment';
import { firstValueFrom } from 'rxjs';
import { CalendarDTO } from 'src/app/interfaces/calendar';
import { CalendarIntegrationDTO } from 'src/app/interfaces/calendarIntegration';
import { FunctionsService } from 'src/app/services/functions.service';
import { CalendarService } from 'src/app/services/calendar.service';
import { CalendarIntegrationService } from 'src/app/services/calendar-integration.service';
import { ListService } from 'src/app/services/list.service';
import { UserDTO } from 'src/app/interfaces/user';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-edit-list',
  imports: [CommonModule,
    FormsModule,
    MatDialogModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatIconModule,
    MatButtonModule],
  templateUrl: './edit-list.component.html',
  styleUrl: './edit-list.component.scss'
})
export class EditListComponent implements OnInit {

  user!: UserDTO;
  isLoggedIn = false;

  envClass = 'prod';
  isEdit = false;
  list?: ListDTO;
  calendar: CalendarDTO;
  calendarIntegration: CalendarIntegrationDTO;
  calendarIntegrations?: CalendarIntegrationDTO[];
  calendars?: CalendarDTO[];
  newSharedEmail: string = '';
  sharedListMembers: SharedListMemberDTO[] = [];

  constructor(
    private calendarIntegrationService: CalendarIntegrationService,
    private listService: ListService,
    private tokenStorageService: TokenStorageService,
    private router: Router,
    public functions: FunctionsService,
    private calendarService: CalendarService,
    public dialogRef: MatDialogRef<EditListComponent>,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    if (data) {
      this.list = data;
      this.isEdit = this.list && this.list.id && this.list.id > -1;
      this.getCalendar();
      this.getSharedListMembers();
    }
  }

  async ngOnInit() {
    this.envClass = `env-${environment.name}`;

    this.isLoggedIn = !!this.tokenStorageService.getToken();
    if (!this.isLoggedIn) {
      this.router.navigate(['home']);
      return;
    }

    this.user = this.tokenStorageService.getUser();
    this.calendars = await firstValueFrom(this.calendarService.getCalendarsForDashboard());
  }

  async getCalendar() {
    if (this.list.calendarId && this.list.calendarId > -1) {
      this.calendar = await firstValueFrom(this.calendarService.getCalendar(this.list.calendarId));
    }
  }

  changeCalendar(calendar: CalendarDTO) {
    this.calendar = calendar;
  }

  async save() {
    if (!this.list.description?.trim()) return;
    if (this.calendar) {
      this.list.calendarId = this.calendar.id;
    } else {
      this.list.calendarId = -1;
    }
    if (this.user) this.list.userId = this.user.id;
    this.list = await firstValueFrom(this.listService.saveList(this.list.id, createList(this.list.userId, this.list.calendarId, this.list.description)))
    this.dialogRef.close({ list: this.list });
  }

  close(): void {
    this.dialogRef.close();
  }

  async getSharedListMembers() {
    if (this.list && this.list.id && this.list.id > -1) {
      this.sharedListMembers = await firstValueFrom(this.listService.getSharedListMembers(this.list.id));
    }
  }

  async addSharedUser() {
    if (this.newSharedEmail && this.newSharedEmail.trim()) {
      const email = this.newSharedEmail.trim().toLowerCase();

      const exists = this.sharedListMembers.some(
        (member) => member.emailAddress.toLowerCase() === email
      );

      if (!exists) {
        let sharedListMember: SharedListMemberDTO = { listId: this.list.id, emailAddress: email }
        sharedListMember = await firstValueFrom(this.listService.addSharedListMember(sharedListMember));
        this.sharedListMembers.push(sharedListMember);
      }
      this.newSharedEmail = ''; // Reset inputveld
    }
  }

  async removeSharedUser(index: number) {
    if (index >= 0 && index < this.sharedListMembers.length) {
      const data = await firstValueFrom(this.listService.removeSharedListMember(this.sharedListMembers[index]));
      this.sharedListMembers.splice(index, 1);
    }
  }
}


